module.exports = __webpack_public_path__ + "images/line_lp/top-triangle_6be4021235f9a12742e0259d33e63bf8.png";